import React, { useContext, useState } from "react";
import { RiDeleteBinLine } from "react-icons/ri";
import { AccountManagementContext } from "../../../context/AccountManagementContext";
import { useDeleteHandler } from "../../../hooks/useDeleteHandler";
import { DeleteAccountUser } from "../../../services/adminApiService/accountManagementApi/AccountManagementApiService";
const AccountManagementList = ({debouncedSearchValue, perPage,currentPage,  }) => {
const { handleDelete } = useDeleteHandler();

    const { loading, userAccountList, fetchUserAccountManagementList, fetchDeleteAccountuser,getAccountUserCount } =
        useContext(AccountManagementContext);

    const [sortColumn, setSortColumn] = useState(null); // holds active sort column
    const [sortAsc, setSortAsc] = useState(true); // holds direction

    const handleSort = (key) => {
        const isSameColumn = sortColumn === key;
        const newSortAsc = isSameColumn ? !sortAsc : true; // if clicking again toggle, else default to asc
        setSortColumn(key);
        setSortAsc(newSortAsc);
        fetchUserAccountManagementList(key, newSortAsc ? "asc" : "desc");
    };


    const deleteHandler = (id) => {
        handleDelete({
           deleteApi: () => DeleteAccountUser(id),
             refreshListApi: () => {
            fetchUserAccountManagementList();
            getAccountUserCount();
           },
            
            successMsg: "User Role deleted successfully"
        });
    };
    return (
        <>
            <div className="card-body">
                {loading ? (
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <div className="w-100 table-responsive">
                        <div id="example_wrapper" className="dataTables_wrapper">
                            <table id="example" className="display w-100 dataTable">
                                <thead>
                                    <tr>
                                        {/*<th>SN</th>*/}
                                        <th
                                            style={{ cursor: "pointer" }}
                                            onClick={() => handleSort("id")}
                                        >
                                            ID
                                            {sortColumn === "name" ? (sortAsc ? "⬆" : "⬇") : "⬆⬇"}
                                        </th>
                                        <th>Full Name</th>
                                        <th>Email</th>
                                        <th>Role</th>
                                        <th
                                            style={{ cursor: "pointer" }}
                                            onClick={() => handleSort("status")}
                                        >
                                            Status
                                            {sortColumn === "status" ? (sortAsc ? "⬆" : "⬇") : "⬆⬇"}
                                        </th>

                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {userAccountList?.data?.data?.length > 0 ? (
                                        userAccountList?.data?.data?.map((data, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{index + 1 + (currentPage - 1) * perPage}</td>
                                                    <td>{data?.name?.slice(0, 100)}</td>
                                                    <td>{data?.email}</td>
                                                    <td>{data?.usp_role_name}</td>
                                                    {/* <td>{data?.activated === "1" ? (
                                                        <span className="status-btn active">Active</span>
                                                    ) : (
                                                        <span className="status-btn inactive">Inactive</span>
                                                    )}</td> */}
                                                    <td>{data?.activated === "1" ? (
                                                        <span className="status-btn active">{data?.status_label}</span>
                                                    ) : (
                                                        <span className="status-btn inactive">{data?.status_label}</span>
                                                    )}</td>

                                                    <td
                                                        style={{ cursor: "pointer" }}
                                                    >
                                                        <div className="d-flex ">
                                                            <a href={`/account/account-profile/${data?.id}`}>
                                                                <div className="icon_wrapper">
                                                                    <i className="bi bi-eye"></i>
                                                                </div>
                                                            </a>


                                                            <div className="icon_wrapper mx-2 " onClick={() => deleteHandler(data?.id)}><RiDeleteBinLine className="text-danger" /></div>
                                                        </div>

                                                    </td>
                                                    {/* <td>{formatDateTime(data?.created_at)}</td> */}
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan="9" className="text-center">
                                                Data is not available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>

        </>
    )
};
export default AccountManagementList;
